import React, { type FC } from 'react';
import Typography from '@mui/material/Typography';
import { useRequest } from 'ahooks';
import { getStats } from '@/api';
import classNames from 'classnames';

export const StatsCard: FC<{
	title: string;
	label?: string;
	allTime: number | undefined;
	last24h: number | undefined;
}> = ({ title, label, allTime, last24h }) => {
	return (
		<div
			className={classNames(
				'flex-1 py-3 flex flex-col items-stretch justify-center gap-1 sm:gap-2 px-9',
				'border-borderPrimary border-b sm:border-b-0 sm:border-r md:border-b md:border-r-0',
				'last:border-none',
			)}
		>
			<Typography variant='appSmallRegular'>{title}</Typography>

			<Typography variant='numsHeading' color='common.textPrimary'>
				{last24h != null ? (
					<>
						{label}
						{last24h.toLocaleString('en-US', { maximumFractionDigits: 0 })}
					</>
				) : (
					<>&nbsp;</>
				)}
			</Typography>
			<Typography variant='appSmallRegular' color='common.textPrimary'>
				{allTime != null ? (
					<>
						{label}
						{allTime.toLocaleString('en-US', { maximumFractionDigits: 0 })}

						<Typography variant='appTinyRegular' color='common.textSecondary'>
							&nbsp;&nbsp;total
						</Typography>
					</>
				) : (
					<>&nbsp;</>
				)}
			</Typography>
		</div>
	);
};

export default function Stats() {
	const { data: stats } = useRequest(getStats);
	return (
		<div className={classNames('flex flex-col sm:flex-row md:flex-col flex-wrap h-full')}>
			<Typography
				variant='appSmallRegular'
				className={classNames(
					'flex flex-row items-stretch justify-start gap-1 sm:gap-2',
					'py-3 px-9',
					'w-full border-borderPrimary border-b',
				)}
				sx={{ fontWeight: 500 }}
			>
				Overview (24h)
			</Typography>
			<StatsCard title='Bridged volume' label='$' allTime={stats?.allTime?.volume} last24h={stats?.last24h?.volume} />
			<StatsCard title='Bridge count' allTime={stats?.allTime?.swaps} last24h={stats?.last24h?.swaps} />
			<StatsCard
				title='Unique wallets'
				allTime={stats?.allTime?.activeTraders}
				last24h={stats?.last24h?.activeTraders}
			/>
		</div>
	);
}
